// src/modules/app-views/_apps/appmulti/leads/seed.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import appService from 'services/appService';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DEFAULT_SEEDS = {
  form: {},
  requiredFields: [],
};

// *******************************************************************************
// MAIN FUNCTION
// Leads have no parametrization modal — seed is a no-op placeholder kept for
// config symmetry (mirrors orders/seed.js structure).
// *******************************************************************************
async function seedLeadsParameters({ moduleId, storedParameters }) {
  if (!moduleId) return;

  const moduleParams = storedParameters?.modules?.[moduleId];

  if (moduleParams && Object.keys(moduleParams).length > 0) {
    return [];
  }

  const results = [];

  try {
    await appService.updateModulePreferences({
      category: 'form',
      moduleId,
      data: DEFAULT_SEEDS.form,
    });
    results.push({ category: 'form', seeded: true, data: DEFAULT_SEEDS.form });
  } catch (error) {
    results.push({ category: 'form', seeded: false, error });
  }

  return results;
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default seedLeadsParameters;
